<template>
  <div class="switch-button" v-if="hasRole">
    <v-btn icon="mdi-account-switch" @click="role = role === 'om' ? 'op' : 'om'"
      v-tooltip="role === 'om' ? '切换为运营角色' : '切换为运维角色'"></v-btn>
  </div>
  <component :is="currentComponent" />
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import OM from './OM/index.vue'
import OP from './OP/index.vue'
import { checkRole } from '@/utils/permission.js'

const localStorageKey = 'workbenchRole'

// 内部权限字符
const innerRoles = ['jd-support', 'jd-project', 'jd-develop']
const hasRole = checkRole(innerRoles)

const role = ref(localStorage.getItem(localStorageKey) || 'op')

watch(role, (newRole) => {
  localStorage.setItem(localStorageKey, newRole)
})

const components = {
  om: OM,
  op: OP
}

// 内部用户保留按钮，外部用户取消按钮，同时只能显示运营视图
const currentComponent = computed(() => {
  if (hasRole) {
    return components[role.value]
  }
  return OP
})

</script>

<style scoped lang="scss">
.switch-button {
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 999;
}
</style>
